export const name = process.env.NODE_ENV;
export const isTest = name === 'test';
export const isProduction = name === 'production';
export const appURL = process.env.NEXT_PUBLIC_APP_URL;
